module.exports = __webpack_public_path__ + "img/744.4ab705eb.jpg";